export const lawProductName = 'Sammlung Arbeitsrecht'
